export default defineNuxtPlugin((nuxtApp) => {
  const online = useOnline();

  if (!online.value) navigateTo("/offline");

  watch(online, (isOnline) => {
    if (!isOnline) {
      navigateTo("/offline");
    } else {
      navigateTo("/");
    }
  });

  if (import.meta.env.PROD) registerPeriodicSync();
});
